module.exports = __webpack_public_path__ + "img/simple_map_img_kor.svg";